
import { computed, defineComponent } from 'vue';
import { Progress } from 'ant-design-vue';
import Card from '@/core/components/Tela/Card.vue';
import UtilitarioMascara from '@/core/utilitarios/UtilitarioMascara';
import { IVendaItemOrdemProducao } from '@/models/Entidades/Vendas/IVenda';

export default defineComponent({
  name: 'VendaItemOrdemProducaoCard',
  components: {
    'a-progress': Progress,
    Card,
  },
  props: {
    ordemProducao: {
      type: Object as () => IVendaItemOrdemProducao,
      required: true,
    },
  },
  setup(props) {
    const statusTexto = computed(() => {
      switch (props.ordemProducao.status) {
        case 0:
          return 'Pendente';
        case 1:
          return 'Produzindo';
        case 2:
          return 'Concluído';
        default:
          return 'Cancelado';
      }
    });

    return { UtilitarioMascara, statusTexto };
  },
});
